// Checking to see whether the module itself should have a container
// 1. Module has container
// 2. Module has no container, however if it exists in template Other, it shouldn't have padding, since template Other has a global container which has its own padding
// 3. Module has no container and isn't a part of template Other, should have some padding (in this case, p-8)

const hasContainer = (moduleContainer, template) => {
    if (moduleContainer) {
        return "container";
    } 
    if (template === "other") {
        return "px-0";
    } 
    return "md:px-8 px-4";
};

export default hasContainer;
